import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { admin } from "../../lib/api";
import { inr } from "../../lib/format";
import { panel, inputCls, PageHead } from "../ui";

const STATUSES = ["", "Pending", "Confirmed", "Processing", "Shipped", "Delivered", "Cancelled", "Refunded"];

export default function Orders() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const p = new URLSearchParams();
    if (status) p.set("status", status);
    if (q) p.set("q", q);
    admin.get(`/admin/orders?${p}`).then((r) => setList(r.data));
  }, [status, q]);

  return (
    <div>
      <PageHead title="Orders">
        <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} className={`${inputCls} w-40`} data-testid="order-search" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={`${inputCls} w-40`} data-testid="order-status-filter">
          {STATUSES.map((s) => <option key={s} value={s}>{s || "All statuses"}</option>)}
        </select>
      </PageHead>
      <div className={`${panel} overflow-x-auto`}>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-widest text-zinc-500 border-b border-zinc-800">
            <th className="p-3">Order</th><th className="p-3">Customer</th><th className="p-3">Date</th><th className="p-3">Payment</th><th className="p-3">Status</th><th className="p-3 text-right">Total</th>
          </tr></thead>
          <tbody>
            {list.map((o) => (
              <tr key={o.id} onClick={() => navigate(`/admin/orders/${o.id}`)} className="border-b border-zinc-900 hover:bg-zinc-900/40 cursor-pointer" data-testid={`order-row-${o.order_number}`}>
                <td className="p-3 text-white font-medium">{o.order_number}</td>
                <td className="p-3 text-zinc-400">{o.contact?.email}</td>
                <td className="p-3 text-zinc-500">{(o.created_at || "").slice(0, 10)}</td>
                <td className="p-3 text-zinc-400">{o.payment_status}</td>
                <td className="p-3"><span className="text-xs uppercase tracking-wider text-zinc-300">{o.status}</span></td>
                <td className="p-3 text-right text-white">{inr(o.total)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-zinc-500">No orders.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
